import { render } from "./OrderPeriod.vue?vue&type=template&id=6b1bc181&scoped=true"
import script from "./OrderPeriod.vue?vue&type=script&lang=js"
export * from "./OrderPeriod.vue?vue&type=script&lang=js"

import "./OrderPeriod.vue?vue&type=style&index=0&id=6b1bc181&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1bc181"]])

export default __exports__